import { Injectable } from "@angular/core";
import { ApiGenericAction } from "@onsip/common/services/api/api-actions";
import { genericApiAction } from "@onsip/common/services/api/onsip-api-action-new";

@Injectable({ providedIn: "root" })
export class SignupCheckVerificationService {
  async signupCheckVerification(VerificationToken: string): Promise<void> {
    await genericApiAction({
      Action: ApiGenericAction.SignupCheckVerification,
      VerificationToken
    });
  }
}
